import { Component, OnInit } from '@angular/core';
// import AOS from 'aos';
@Component({
  selector: 'app-chefs',
  templateUrl: './chefs.component.html',
  styleUrls: ['./chefs.component.css']
})
export class ChefsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // AOS.init();
  }

}
